// Rățuștele câștigătoare — Cursa Rățuștelor pe Bega 2026.
// Sursa: poster oficial Rotaract Timișoara.

export const TOP_WINNERS = [
  { place: "Locul I", number: "4967" },
  { place: "Locul II", number: "4418" },
  { place: "Locul III", number: "269" },
];

export const OTHER_WINNERS = [
  "5068",
  "1399",
  "3622",
  "4917",
  "2838",
  "3453",
  "2152",
  "4466",
  "4980",
  "4957",
  "1818",
  "3822",
  "5549",
  "4601",
  "4640",
  "4140",
  "869",
  "1309",
  "252",
  "3859",
  "5399",
];

// Momente în care premiile pot fi revendicate.
export const PRIZE_CLAIM_EVENTS = [
  {
    date: "Marți, 9 iunie 2026",
    time: "Între orele 19:30 – 21:00",
    location:
      "Universitatea de Vest din Timișoara, Bulevardul Vasile Pârvan nr. 4",
  },
  {
    date: "Sâmbătă, 13 iunie 2026",
    time: "Între orele 11:00 – 15:00",
    location:
      "Parcarea din spatele magazinului Bega, Timișoara, în cadrul evenimentului „Condu prudent, alege viața!”",
  },
];
